import { useEffect, useState } from 'react';
import {
  useApi,
  useTranslationRef,
  oauthRequestApiRef,
  PendingOAuthRequest,
} from '@backstage/frontend-plugin-api';
import { useTheme } from '@material-ui/core/styles';
import { Button, Dialog, DialogContent } from '@material-ui/core';
import { spikeOAuthRequestDialogTranslationRef } from './translation';
import { useStyles } from './SpikeOAuthRequestDialog.style';

const LOGO_LIGHT = '/flow-logo-indigo.png';
const LOGO_DARK = '/flow-logo-white.png';

export function SpikeOAuthRequestDialog() {
  const classes = useStyles();
  const theme = useTheme();
  const oauthRequestApi = useApi(oauthRequestApiRef);
  const { t } = useTranslationRef(spikeOAuthRequestDialogTranslationRef);
  const [requests, setRequests] = useState<PendingOAuthRequest[]>([]);

  useEffect(() => {
    const subscription = oauthRequestApi.authRequest$().subscribe(setRequests);
    return () => subscription.unsubscribe();
  }, [oauthRequestApi]);

  const handleSignInAgain = () => {
    requests.forEach(request => request.trigger());
  };

  const handleCancel = () => {
    requests.forEach(request => request.reject());
  };

  return (
    <Dialog
      open={requests.length > 0}
      fullWidth
      maxWidth="xs"
      classes={{ paper: classes.paper }}
      aria-labelledby="spike-oauth-request-dialog-title"
    >
      <DialogContent>
        <img
          className={classes.logo}
          src={theme.palette.type === 'dark' ? LOGO_DARK : LOGO_LIGHT}
          alt="CI&T Spike"
        />
        <h2 id="spike-oauth-request-dialog-title" className={classes.title}>
          {t('dialog.title')}
        </h2>
        <p className={classes.message}>{t('dialog.message')}</p>
        <Button
          className={classes.primaryButton}
          onClick={handleSignInAgain}
          disableElevation
        >
          {t('dialog.primaryAction')}
        </Button>
        <Button className={classes.secondaryButton} onClick={handleCancel}>
          {t('dialog.secondaryAction')}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
